import { gql } from '@apollo/client/core';

/**
 * Selections for the superadmin account screens. Keep these in step with `Client.ts` — every field
 * selected here is mapped there, and nothing more is selected than is mapped.
 */

export const INTERNAL_ACCOUNT_LIST_FIELDS = gql`
  fragment InternalAccountListFields on Account {
    id
    name
    onboarded
    feeStructureId
    feeStructure {
      id
      name
    }
    owner {
      id
      name
      email
    }
  }
`;

/**
 * The loan selection, shared by the account read and by `createSoundcheckLoan` — both map their
 * `Loan` through the same `SoundcheckLoan.fromGql`, so selecting different fields on the two paths
 * would hand it a partial loan from one of them.
 */
export const INTERNAL_SOUNDCHECK_LOAN_FIELDS = gql`
  fragment InternalSoundcheckLoanFields on Loan {
    id
    loanType
    originalPrincipalBalance
    outstandingBalance
    perTicketFeePercentage
    status
    createdAt
    updatedAt
    loanPayments {
      id
      amount
      status
      createdAt
    }
  }
`;

/**
 * The list fields plus everything the edit form needs.
 *
 * `cartLockDuration` matters more than it looks: the AppSchema fragments this replaces never
 * selected it, so the edit form always fell back to its `15` default and wrote that back over the
 * stored value on every save. Selecting it here is what stops that.
 */
export const INTERNAL_ACCOUNT_DETAIL_FIELDS = gql`
  fragment InternalAccountDetailFields on Account {
    ...InternalAccountListFields
    cartLockDuration
    soundcheckStripeAccountId
    whitelabelConfigId
    soundcheckLoan {
      ...InternalSoundcheckLoanFields
    }
    soundcheckLoanLimits {
      feePercentageMin
      feePercentageMax
      maxAmount
    }
  }
  ${INTERNAL_ACCOUNT_LIST_FIELDS}
  ${INTERNAL_SOUNDCHECK_LOAN_FIELDS}
`;
